import React, { FC, useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import { PaymentsContext } from '../../contexts';

import { waitForGlobalVariable } from './utils';

import { CDN_URL, SDK_VARIABLE } from '../../constants';
import { PaymentsSDKConstructable, PaymentsSDK } from '../../types';

type PaymentsContainerProps = {
  /**
   * Content delivery network url for payments SDK
   */
  bundleUrl?: string;
  /**
   * React children nodes
   */
  children?: React.ReactNode;
};

const PaymentsContainer: FC<PaymentsContainerProps> = ({
  children,
  bundleUrl = CDN_URL,
}) => {
  const { i18n } = useTranslation();
  const [isLoaded, setLoaded] = useState(false);

  const paymentsSDK = useRef<PaymentsSDK>(null);

  useEffect(() => {
    i18n.loadNamespaces(['payment-profile']);

    waitForGlobalVariable<PaymentsSDKConstructable>(
      SDK_VARIABLE,
      (error, PaymentsConstuctable) => {
        if (!error && PaymentsConstuctable) {
          paymentsSDK.current = new PaymentsConstuctable();
          setLoaded(true);
        }
      }
    );
  }, []);

  return (
    <>
      {isLoaded && (
        <PaymentsContext.Provider value={{ paymentsSDK: paymentsSDK.current }}>
          {children}
        </PaymentsContext.Provider>
      )}
      <Helmet>
        <script type="text/javascript" src={bundleUrl} />
      </Helmet>
    </>
  );
};

export default PaymentsContainer;
